var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AboutTab',{style:(!_vm.$store.state.roiTrayVisible && _vm.$store.state.activeModals.about ? 'height: 65px !important' : ''),attrs:{"id":"about-tab"},on:{"bevel-bar-clicked":function($event){return _vm.$store.dispatch('openAboutModal')}}},[_c('FontAwesome',{attrs:{"icon":"paw"}}),_c('p',{attrs:{"id":"about-tab-label"}},[_vm._v(" About ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }